import React, { useState } from "react";
import { kaspiLink } from "../../../utils/getProductListCardDetails";

import { ProductImage } from "./ProductImageKaspi";
import GraphPopup from "./GraphPopup";
import ProductAge from "./ProductAge";

const ProductCard = ({ product, onBrandClick, visibleColumns = {} }) => {
  const [isGraphPopupOpen, setIsGraphPopupOpen] = useState(false);

  const formatNumber = (num) => {
    return new Intl.NumberFormat("ru-RU").format(num);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("ru-RU", {
      //   style: "currency",
      //   currency: "KZT",
      minimumFractionDigits: 0,
    }).format(amount);
  };

  const handleGraphClick = () => {
    setIsGraphPopupOpen(true);
  };

  const handleCloseGraphPopup = () => {
    setIsGraphPopupOpen(false);
  };

  const handleBrandClick = () => {
    if (onBrandClick && product.brand) {
      onBrandClick(product.brand);
    }
  };

  return (
    <div className="col-12 mb-3">
      <div className="card shadow-sm">
        <div className="card-body py-3">
          <div className="tw-flex tw-items-center" style={{ minHeight: "60px" }}>
            {visibleColumns.graph !== false && (
              <div className="tw-flex-1 tw-flex tw-justify-center">
                <button
                  className="tw-flex-shrink-0 tw-border-2 tw-border-blue-600 tw-rounded-md tw-p-2 tw-flex tw-items-center tw-justify-center tw-text-blue-600 hover:tw-bg-blue-50 tw-transition-colors"
                  onClick={handleGraphClick}
                  title="Посмотреть график"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 3v18h18"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="m19 9-5 5-4-4-3 3"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            )}
            {visibleColumns.brand !== false && (
              <div className="tw-flex-1 tw-text-center">
                <span
                  className="tw-text-[4px] md:tw-text-xs tw-font-medium tw-cursor-pointer tw-text-[#007bff] tw-underline"
                  onClick={handleBrandClick}
                  title="Фильтровать по бренду"
                >
                  {product.brand}
                </span>
              </div>
            )}
            {visibleColumns.photo !== false && (
              <div className="tw-flex-1 tw-text-center">
                <ProductImage product={product} />
              </div>
            )}
            {visibleColumns.product_name !== false && (
              <div className="tw-flex-1">
                <div>
                  <h6 className="tw-md-1 tw-text-black tw-font-bold tw-text-[4px] md:tw-text-xs">
                    {product.product_name}
                  </h6>
                  <div className="mb-1">
                    <a
                      href={kaspiLink(product.product_name, product.sku)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary text-decoration-none"
                      style={{ fontSize: "12px" }}
                    >
                      Ссылка на каспи
                    </a>
                  </div>
                  <small className="text-muted">АРТ: {product.sku}</small>
                  <div>
                    <ProductAge createdTime={product.created_time} />
                  </div>
                </div>
              </div>
            )}
            {visibleColumns.root_category !== false && (
              <div className="tw-flex-1 tw-text-center">
                <span className="tw-text-[4px] md:tw-text-xs">
                  {product.root_category}
                </span>
              </div>
            )}
            {visibleColumns.category_2 !== false && (
              <div className="tw-flex-1 tw-text-center">
                <span className="tw-text-[4px] md:tw-text-xs">
                  {product.category_2}
                </span>
              </div>
            )}
            {visibleColumns.category_3 !== false && (
              <div className="tw-flex-1 tw-text-center">
                <span className="tw-text-[4px] md:tw-text-xs">
                  {product.category_3}
                </span>
              </div>
            )}
            {visibleColumns.category_4 !== false && (
              <div className="tw-flex-1 tw-text-center">
                <span className="tw-text-[4px] md:tw-text-xs">
                  {product.category_4 || "-"}
                </span>
              </div>
            )}
            {visibleColumns.sellers_count !== false && (
              <div className="tw-flex-1 tw-text-center">
                <span className="tw-font-bold tw-text-[4px] md:tw-text-xs">
                  {formatNumber(product.current_sellers_count)}
                </span>
              </div>
            )}
            {visibleColumns.price !== false && (
              <div className="tw-flex-1 tw-text-center">
                <span className="tw-font-bold tw-text-[4px] md:tw-text-xs">
                  {formatCurrency(product.current_avg_price)}
                </span>
              </div>
            )}
            {visibleColumns.sells !== false && (
              <div className="tw-flex-1 tw-text-center">
                <span className="tw-font-bold tw-text-[4px] md:tw-text-xs">
                  {formatNumber(product.current_sells_count)}
                </span>
              </div>
            )}
            {visibleColumns.gmv !== false && (
              <div className="tw-flex-1 tw-text-center">
                <span className="tw-font-bold tw-text-[4px] md:tw-text-xs">
                  {formatCurrency(product.current_gmv)}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <GraphPopup
        isOpen={isGraphPopupOpen}
        onClose={handleCloseGraphPopup}
        productData={product}
        productName={product.product_name}
      />
    </div>
  );
};

export default ProductCard;
